import { StepIconProps, styled, Theme } from '@mui/material';
import React, { FC } from 'react';

type StepState = {
  active?: boolean;
  completed?: boolean;
  error?: boolean;
};

const getStepIconColor = (state: StepState, theme: Theme) => {
  if (state.completed) return theme.palette.success.main;
  if (state.active) return theme.palette.heaven.main || theme.palette.primary.main;
  return theme.palette.common.white;
};

const ICON_SIZE = 32;

const StepIconRoot = styled('div')<{
  state: StepState;
}>(({ theme, state }) => {
  const inactive = !state.active && !state.completed;
  const borderWidth = inactive ? 1.5 : 0;

  return {
    backgroundColor: getStepIconColor(state, theme),
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: ICON_SIZE - borderWidth * 2,
    width: ICON_SIZE - borderWidth * 2,
    borderColor: theme.palette.grey['100'],
    borderWidth: borderWidth,
    borderStyle: inactive ? 'solid' : 'hidden',
    color: inactive ? theme.palette.grey['100'] : theme.palette.common.white,
    '& .StepIcon': {
      width: ICON_SIZE * 0.75,
      height: ICON_SIZE * 0.75
    },
    '& > p': {
      color: 'inherit !important'
    }
  };
});

export const StepIcon = (icon: React.ElementType) => {
  const fn: FC<StepIconProps> = ({ active, completed, error, className }) => {
    const Icon = icon;
    return (
      <StepIconRoot state={{ active, completed, error }} className={className}>
        <Icon className="StepIcon" />
      </StepIconRoot>
    );
  };

  return fn;
};
